import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import Image from 'next/image';
import _isUndefined from 'lodash/isUndefined';

import { ReviewRating } from './reviewRating';
import { formatDate, parseDateWithoutTimezone } from '@utils/dates';
import { BaseComponentProps } from '@utils/types/baseComponents';
import { getSourceIcon } from '@components/listing/listingReview/utils';
import ShowMoreIcon from '@assets/images/review-show-more.svg';
import { ListingUserReviewType } from '@utils/types/review';

import styles from './styles.module.scss';

type Props = {
  review: ListingUserReviewType;
} & BaseComponentProps;

export function Review(props: Props) {
  const { containerStyle, review } = props;
  const [isClamped, setIsClamped] = useState<boolean>();
  const reviewRef = useRef<any>(null);

  useEffect(() => {
    setTimeout(() => {
      if (
        reviewRef.current?.scrollHeight - reviewRef.current?.offsetHeight >=
        1
      ) {
        setIsClamped(true);
      }
    }, 100);
  }, [review.details]);

  return (
    <div className={clsx([styles.review, containerStyle])}>
      <div className={styles.review__header}>
        <div className={styles.review__info}>
          <div className={styles.name}>
            {review.user?.first_name || review.reviewer_name}
          </div>

          <div className={styles.date}>
            {formatDate(
              parseDateWithoutTimezone(
                review.submitted_at || review.updated_at
              ),
              'MMMM, yyyy'
            )}
          </div>
        </div>

        <ReviewRating rating={+review.rating || review.overall} type="user" />
      </div>

      <div
        className={clsx([
          styles.review__text,
          (_isUndefined(isClamped) || isClamped) && styles.review__text_clamp,
        ])}
        ref={reviewRef}
      >
        {review.details}
      </div>

      <div className={styles.review__footer}>
        {isClamped && (
          <div
            className={styles.review__showMore}
            onClick={() => setIsClamped(false)}
            role="button"
          >
            <Image src={ShowMoreIcon} alt="show more" />
            <div>Show More</div>
          </div>
        )}

        <div className={styles.review__source}>
          <Image src={getSourceIcon(review.source)} alt="source icon" />
        </div>
      </div>
    </div>
  );
}
